export const COMBOBOX_LABEL_SIZES = {
  EXTRA_SMALL: 'xs',
  SMALL: 'sm',
  DEFAULT: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl',
};

export default {
  COMBOBOX_LABEL_SIZES,
};
